import { render, staticRenderFns } from "./PrescriptionRecentlyUpdatedPopup.vue?vue&type=template&id=d39d2d8a&"
import script from "./PrescriptionRecentlyUpdatedPopup.vue?vue&type=script&lang=js&"
export * from "./PrescriptionRecentlyUpdatedPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
